export const expostProjectToCO2Interventions = (expostProject, plantingYear) => {

  const expostHasInterventions = expostProject && expostProject.length &&
    Object.keys(expostProject[0])
      .filter(key => key !== 'inventories' && key !== 'intervention_zone_id' && key !== 'prediction' && key !== 'uuid')
      .filter(item => expostProject[0][item].length > 0).length > 0;

  return expostHasInterventions
    ? Object.keys(expostProject[0])
      .filter(key => key !== 'inventories' && key !== 'intervention_zone_id' && key !== 'prediction' && key !== 'uuid')
      .filter(item => expostProject[0][item].length > 0)
      .flatMap(type => expostProject[0][type]
        .flatMap(item => ({
          co2InterventionType: type,
          year: plantingYear + item.age,
          saved: true,
          ...item
        })))
      .sort((a, b) => a.age - b.age)
    : [];

};





